<template>
  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66667 10.1667H7.33333V11.5H2.66667V10.1667ZM2.66667 7.50004H9.33333V8.83337H2.66667V7.50004ZM2.66667 4.83337H9.33333V6.16671H2.66667V4.83337ZM10.6667 2.16671H7.88C7.6 1.39337 6.86667 0.833374 6 0.833374C5.13333 0.833374 4.4 1.39337 4.12 2.16671H1.33333C1.24 2.16671 1.15333 2.17337 1.06667 2.19337C0.806667 2.24671 0.573333 2.38004 0.393333 2.56004C0.273333 2.68004 0.173333 2.82671 0.106667 2.98671C0.0400001 3.14004 0 3.31337 0 3.50004V12.8334C0 13.0134 0.0400001 13.1934 0.106667 13.3534C0.173333 13.5134 0.273333 13.6534 0.393333 13.78C0.573333 13.96 0.806667 14.0934 1.06667 14.1467C1.15333 14.16 1.24 14.1667 1.33333 14.1667H10.6667C11.4 14.1667 12 13.5667 12 12.8334V3.50004C12 2.76671 11.4 2.16671 10.6667 2.16671ZM6 2.00004C6.27333 2.00004 6.5 2.22671 6.5 2.50004C6.5 2.77337 6.27333 3.00004 6 3.00004C5.72667 3.00004 5.5 2.77337 5.5 2.50004C5.5 2.22671 5.72667 2.00004 6 2.00004ZM10.6667 12.8334H1.33333V3.50004H10.6667V12.8334Z"
      fill="currentColor" />
  </svg>
</template>

<script>
  export default {
    name: 'Assignment'
  }
</script>
